import { useEffect } from 'react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { fetchMe } from '../lib/api.js';

export const Route = createFileRoute('/app')({
  component: AppDispatcher,
});

/** Post-login dispatcher: route to onboarding or the first store dashboard. */
function AppDispatcher() {
  const navigate = useNavigate();
  const { data, isLoading, isError, refetch } = useQuery({ queryKey: ['me'], queryFn: fetchMe });

  useEffect(() => {
    if (isLoading || isError) return;
    // Only a confirmed "not signed in" (null) goes to sign-in.
    if (data === null) {
      void navigate({ to: '/signin' });
      return;
    }
    if (data) {
      const first = data.memberships[0];
      if (!first) void navigate({ to: '/onboarding' });
      else void navigate({ to: '/admin/$slug', params: { slug: first.slug } });
    }
  }, [data, isLoading, isError, navigate]);

  if (isError) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center gap-4 text-muted-foreground">
        <p>Couldn’t load your account. Check your connection and try again.</p>
        <button
          className="rounded-md border border-border px-3 py-1.5 text-sm hover:bg-accent"
          onClick={() => void refetch()}
        >
          Retry
        </button>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen items-center justify-center text-muted-foreground">
      Loading…
    </div>
  );
}
